@if (totalItems > 0) {
  <div class="pagination-container">
    <div class="pagination-info">
      Showing <strong>{{ (currentPage - 1) * itemsPerPage + 1 }}</strong> to
      <strong>{{ Math.min(currentPage * itemsPerPage, totalItems) }}</strong> of
      <strong>{{ totalItems }}</strong> results
    </div>
    <ul class="pagination-list">
      <!-- Previous Button -->
      <li class="pagination-item">
        <button class="pagination-btn icon-btn" [disabled]="currentPage === 1" (click)="prevPage()"
          aria-label="Previous page">
          <hugeicons-icon [icon]="arrowLeftIcon" [size]="16" color="currentColor"></hugeicons-icon>
        </button>
      </li>
      <!-- Page Buttons (only show if more than 1 page) -->
      @for (page of pages; track page) {
        <li class="pagination-item">
          <button class="pagination-btn" [class.active]="page === currentPage" (click)="setPage(page)">
            {{ page }}
          </button>
        </li>
      }
      <!-- Next Button -->
      <li class="pagination-item">
        <button class="pagination-btn icon-btn" [disabled]="currentPage === totalPages" (click)="nextPage()"
          aria-label="Next page">
          <hugeicons-icon [icon]="arrowRightIcon" [size]="16" color="currentColor"></hugeicons-icon>
        </button>
      </li>
    </ul>
  </div>
}
